import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const LineSpacingDefault = (props) => (
  <SvgIcon width="25" height="12" viewBox="0 0 25 12" {...props}>
    <rect y="10" width="25" height="2" rx="1" fill="currentColor" />
    <rect y="5" width="25" height="2" rx="1" fill="currentColor" />
    <rect width="25" height="2" rx="1" fill="currentColor" />
  </SvgIcon>
);

export default LineSpacingDefault;
